/**
 * Ein Projekt als Listenzeile (13.10.2026) — am Telefon die einzige Ansicht, am
 * Rechner wählbar neben den Kacheln. Ziel: möglichst viele Projekte auf einen
 * Blick, je Projekt nur das Wichtigste — Titel, Kunde · Ort und was als Nächstes
 * dran ist. Betrag und Statuswahl zeigt die Zeile nur am Rechner.
 */
import { Link, useNavigate } from "react-router-dom";
import type { ProjektUebersicht } from "../../lib/types";
import type { ProjektPhaseZeile } from "../../lib/projektLage";
import { fmtEUR } from "../../lib/projekte";
import { StatusPille, statusAuswahl, type StatusWahl } from "./ProjektKarte";

export default function ProjektZeile({ p, phase, wahl }: { p: ProjektUebersicht; phase?: ProjektPhaseZeile; wahl: StatusWahl }) {
  const navigate = useNavigate();
  const { sid } = statusAuswahl(p, wahl.optionen);
  const netto = Number(p.nettowert || 0);
  const unter = [p.kunde_name, p.ort].filter(Boolean).join(" · ");
  const schritt = p.projektart !== "pflege" ? phase?.schritt?.text : "";
  return (
    <article className="vg-proj-zeile" onClick={() => navigate(`/projekte/${p.id}`)}>
      <span className={"vg-proj-zeile-seite s-" + sid} aria-hidden="true" />
      <div className="vg-proj-zeile-haupt">
        <Link className="vg-proj-zeile-titel" to={`/projekte/${p.id}`} onClick={(e) => e.stopPropagation()}>
          {p.title || "—"}
        </Link>
        {unter && <div className="vg-proj-zeile-unter">{unter}</div>}
        {(schritt || phase?.ueberfaellig) && p.projektart !== "pflege" && (
          <div className="vg-proj-zeile-schritt">
            {phase?.ueberfaellig && <span className="ph-marke is-rot">überfällig</span>}
            {schritt && <span>→ {schritt}</span>}
          </div>
        )}
      </div>
      <div className="vg-proj-zeile-rechts">
        {netto > 0 && <span className="vg-proj-zeile-betrag">{fmtEUR(netto)}</span>}
        <StatusPille p={p} wahl={wahl} />
      </div>
      <span className="vg-proj-zeile-pfeil" aria-hidden="true">›</span>
    </article>
  );
}
